export enum EStore {
	ALBUMS = 'albumsStore',
	ARTISTS = 'artistsStore',
	PLAYLISTS = 'playlistsStore',
	TRACKS = 'tracksStore',
	USERS = 'usersStore',
}
